import { css } from "react-emotion";

export const container = css`
  margin: 25px 55px auto 55px;
`;

export const tableStyle = css `
  background: white;
  width: 100%;
  width: 100%;
  height: 100%;
  padding: 20px; 
  max-height: 70vh;
  overflow-y: scroll;

  td, th {
    border: 1px solid #dddddd;
    text-align: left;
    padding: 8px;
  }

  tr:nth-child(even) {
    background-color: #dddddd;
  }
`;